import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { useState, useEffect, useRef } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const theme = createTheme({
    components: {
        MuiTypography: {
            styleOverrides: {
                caption: {
                    marginTop: '7px !important',
                    marginLeft: '7px !important',
                    marginRight: '24px !important',
                    color: "rgba(0, 0, 0, 0.54)",
                    textAlign: 'center',
                    fontWeight: '1000 !important',
                }
            }
        },
        MuiFormGroup: {
            styleOverrides: {
                root: {
                    marginTop: '8px',
                    marginLeft: "20px"
                }
            }
        }
    },
});

const TableViewCol = ({ columns, options, components = {}, onColumnUpdate, updateColumns }) => {
    const textLabels = options.textLabels.viewColumns;
    const CheckboxComponent = components.Checkbox || Checkbox;

    const handleColChange = index => {
        onColumnUpdate(index);
    };

    const firstRun = useRef(true);
    const [showAll, setShowAll] = useState(true)

    useEffect(() => {
        if (firstRun.current) {
            firstRun.current = false;
            return;
        }
        let newColumns = columns.map(col => {
            let newCol = Object.assign({}, col);
            newCol.display = showAll.toString();
            return newCol;
        });
        updateColumns(newColumns);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showAll])

    const handleColsChange = () => {
        setShowAll(showAll => !showAll)
    }


    return (
        <ThemeProvider theme={theme}>
            <FormControl component={'fieldset'} aria-label={textLabels.titleAria}>
                <Typography variant="caption"
                >
                    {textLabels.title}
                </Typography>

                <FormGroup>
                    <CheckboxComponent
                        color="primary"
                        onChange={handleColsChange}
                        checked={showAll}
                        value=""
                    />
                    {columns.map((column, index) => {
                        return (
                            column.display !== 'excluded' &&
                            column.viewColumns !== false && (
                                <FormControlLabel
                                    key={index}
                                    control={
                                        <CheckboxComponent
                                            color="primary"
                                            onChange={() => handleColChange(index)}
                                            checked={column.display === 'true'}
                                            value={column.name}
                                        />
                                    }
                                    label={column.label}
                                />
                            )
                        );
                    })}
                </FormGroup>
            </FormControl>
        </ThemeProvider>
    );
};

export default TableViewCol;